import { gql, useApolloClient } from "@apollo/client";
import {
  PriceCalculatorSailingsV2Query,
  PriceCalculatorSailingsV2QueryVariables,
} from "@/gql/graphql";
import { useEffect, useState } from "react";

// FIXME: Rename when old price calc is removed
const query = gql`
  fragment PriceCalcSailings on Sailing {
    id
    departureTime
    sailingTypeCode
    statusCode
  }
  query MultilegPriceCalculatorSailingsV2(
    $routeCode: String!
    $departureDate: String!
  ) {
    productPrice {
      sailings {
        byRouteCodeDeparture(
          routeCode: $routeCode
          departureDate: $departureDate
        ) {
          ...PriceCalcSailings
        }
      }
    }
  }
`;

export function useMultilegSailingsByRouteCodeDepartureDate(
  routeCodePairs: { routeCode: string; departureDate: string }[],
  skip = false
) {
  const [loading, setLoading] = useState(false);
  const [multilegSailings, setMultilegSailings] = useState<any>();
  const client = useApolloClient();

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const result = await Promise.all(
        routeCodePairs.map(({ routeCode, departureDate }) =>
          client
            .query<
              PriceCalculatorSailingsV2Query,
              PriceCalculatorSailingsV2QueryVariables
            >({ query, variables: { routeCode, departureDate } })
            .then((response) => {
              const sailings =
                response?.data?.productPrice.sailings?.byRouteCodeDeparture?.filter(
                  (sailing) =>
                    sailing.statusCode.toUpperCase() === "A" ||
                    sailing.statusCode.toUpperCase() === "F"
                );

              return {
                routeCode,
                departureDate,
                sailings,
              };
            })
        )
      );

      setMultilegSailings(result);
      setLoading(false);
    };

    if (skip) return;
    load();
  }, [routeCodePairs, skip]);

  return { loading, multilegSailings };
}
